module.exports = __webpack_public_path__ + "static/media/pe.23591f9d.svg";